export const truncateText = (text: string, maxLength: number) =>
  text.length <= maxLength ? text : text.substring(0, maxLength) + '...';

export const getDisplayName = (item: any | null) => {
  if (!item) return '';
  return 'brandName' in item ? item.brandName : item.itemType ?? '';
};
